import { Routes } from "@angular/router";

export const AppRoutes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./features/diaspora-group/diaspora-group-landing.component").then(
        (m) => m.DiasporaGroupLandingComponent,
      ),
    title: "Diaspora Group, Banque, Immo, Academy",
  },
  {
    path: "piliers/:id",
    loadComponent: () =>
      import("./features/piliers/pillar-detail.component").then(
        (m) => m.PillarDetailComponent,
      ),
    title: "Pilier, Diaspora Group",
  },
  {
    path: "**",
    redirectTo: "",
  },
];
